import type { ColTypeDef, ValueFormatterParams } from 'ag-grid-community';
import { useSPIntl } from 'hooks/useIntl';
import { useMemo } from 'react';

import {
  dateTimeFormatOptions,
  defaultFilterOptions,
  makeDateFilterComparatorWithParser,
  makeGridDateSortComparatorWithParser,
  parseDate,
  parseDateTime,
} from './utils';

export function useDateTimeColumnType<T>(): ColTypeDef<T> {
  const { formatDate } = useSPIntl();
  return useMemo(
    () => ({
      comparator: makeGridDateSortComparatorWithParser(parseDateTime),
      valueFormatter: ({ value }: ValueFormatterParams) =>
        value ? formatDate(new Date(value), dateTimeFormatOptions) : '',
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: makeDateFilterComparatorWithParser(parseDate),
        filterOptions: defaultFilterOptions,
        inRangeInclusive: true,
      },
    }),
    [formatDate],
  );
}

export function useServerSideDateTimeColumnType<T>(): ColTypeDef<T> {
  const { formatDate } = useSPIntl();
  return useMemo(
    () => ({
      comparator: makeGridDateSortComparatorWithParser(parseDateTime),
      valueFormatter: ({ value }: ValueFormatterParams) =>
        value ? formatDate(new Date(value), dateTimeFormatOptions) : '',
    }),
    [formatDate],
  );
}
